import React, { useState, useEffect } from "react";
import { Sparkles, Check } from "lucide-react";

export function Step4Processing({ t }) {
  const lines = [t.wizard.s4.line1, t.wizard.s4.line2, t.wizard.s4.line3, t.wizard.s4.line4, t.wizard.s4.line5];
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const int = setInterval(() => setIdx((i) => Math.min(i + 1, lines.length - 1)), 4500);
    return () => clearInterval(int);
    // eslint-disable-next-line
  }, []);
  return (
    <div className="text-center py-10" data-testid="wizard-step-4">
      <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-[#FAF6F0] border border-[#EAE5DB] flex items-center justify-center">
        <Sparkles className="w-9 h-9 text-[#D95D39] animate-pulse" />
      </div>
      <h2 className="font-heading font-bold text-3xl text-[#292524] mb-8">{t.wizard.s4.title}</h2>
      <div className="max-w-md mx-auto space-y-3 text-left">
        {lines.map((l, i) => (
          <div
            key={i}
            className={`flex items-center gap-3 transition-opacity ${i <= idx ? "opacity-100" : "opacity-30"}`}
            data-testid={`processing-line-${i}`}
          >
            {i < idx ? (
              <Check className="w-5 h-5 text-[#3B8268] flex-shrink-0" />
            ) : i === idx ? (
              <div className="pulse-dot flex-shrink-0"></div>
            ) : (
              <div className="w-2.5 h-2.5 rounded-full bg-[#EAE5DB] flex-shrink-0"></div>
            )}
            <div className="text-[#57534E]">{l}</div>
          </div>
        ))}
      </div>
      <div className="mt-8 text-sm text-[#78716C]">{t.wizard.s4.wait}</div>
    </div>
  );
}
